import { faBan } from '@fortawesome/pro-solid-svg-icons/faBan';
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons/faExclamationTriangle';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';

/**
 * Fraud severity levels from backend fraud detection system
 * Used to map fraud indicators to blocking behaviors
 *
 * Matches backend FraudSeverity enum
 */
export const FraudSeverity = {
  Info: 1,
  Warning: 2,
  High: 3,
  Critical: 4,
} as const;

export type FraudSeverityValue = (typeof FraudSeverity)[keyof typeof FraudSeverity];

/**
 * Blocking behavior types for loss prevention features
 * Shared between settings page and order details
 */
export const BLOCKING_BEHAVIOR = {
  BLOCKS: 'blocks',
  FLAGS: 'flags',
  INFO: 'info',
} as const;

export type BlockingBehavior = (typeof BLOCKING_BEHAVIOR)[keyof typeof BLOCKING_BEHAVIOR];

/**
 * Configuration for blocking behavior UI elements
 * Maps blocking behavior to icon, message key, and CSS class
 * Shared between settings cards and order details fraud indicators
 */
export const BLOCKING_CONFIG = {
  [BLOCKING_BEHAVIOR.BLOCKS]: { messageKey: 'blocksShipping', icon: faBan, className: 'blocking-blocks' },
  [BLOCKING_BEHAVIOR.FLAGS]: { messageKey: 'flagsForReview', icon: faExclamationTriangle, className: 'blocking-flags' },
  [BLOCKING_BEHAVIOR.INFO]: { messageKey: 'informationalOnly', icon: faInfoCircle, className: 'blocking-info' },
} as const;

/**
 * Fraud indicator codes from backend fraud detection system
 * These match the fraudIndicatorCode values returned by the API
 */
export const FRAUD_INDICATOR_CODES = {
  BLACKLIST_FUZZY: 'BLACKLIST_FUZZY',
  BLACKLIST_EXACT: 'BLACKLIST_EXACT',
  HIGH_VALUE: 'HIGH_VALUE',
  VELOCITY: 'VELOCITY',
  RUSH_SHIPPING_FIRST_ORDER: 'RUSH_SHIPPING_FIRST_ORDER',
  UNUSUAL_ORDER_TIME: 'UNUSUAL_ORDER_TIME',
  FREIGHT_FORWARDER: 'FREIGHT_FORWARDER',
} as const;

/**
 * Fraud indicator categories from backend fraud detection system
 * These match the category values returned by the API
 */
export const FRAUD_CATEGORIES = {
  BLACKLIST_FUZZY: 'Blacklist',
  BLACKLIST_EXACT: 'Blacklist',
  HIGH_VALUE: 'HighValue',
  BEHAVIOR: 'Behavior',
  TIMING: 'Timing',
  INFORMATIONAL: 'Informational',
  VELOCITY: 'Velocity',
} as const;
